import type { ManualTransactionModel } from '@/reducers/admin/allTransactions.slice'
import type { DuplicateRowGroup } from '@/features/transactions/transactions.slice'

export interface UploadDuplicateGroup {
  transaction: ManualTransactionModel
  occurrences: number
  inDatabase: boolean
}

export interface UploadDuplicatePageModel {
  groupId: string
  type: 'database-dup' | 'spreadsheet-dup'
  transaction: ManualTransactionModel
  numOccurrencesToShow: number
}

export const partitionDuplicates = (
  models: ManualTransactionModel[],
  rowGroups: DuplicateRowGroup[]
) => {
  const duplicateIndices = new Set(rowGroups.flatMap((group) => group.indices))

  const validTransactions = models.filter(
    (_, index) => !duplicateIndices.has(index)
  )

  const duplicateGroups = rowGroups.flatMap<UploadDuplicateGroup>(
    ({ indices, inDatabase }) => {
      const firstIndex = indices[0]
      const transaction =
        firstIndex !== undefined ? models[firstIndex] : undefined

      return transaction
        ? [{ transaction, occurrences: indices.length, inDatabase }]
        : []
    }
  )

  return { validTransactions, duplicateGroups }
}

export const buildDuplicatePages = (groups: UploadDuplicateGroup[]) => {
  const databasePages: UploadDuplicatePageModel[] = []
  const spreadsheetPages: UploadDuplicatePageModel[] = []

  groups.forEach((group, index) => {
    const groupId = `duplicate-group-${index}`

    if (group.inDatabase) {
      databasePages.push({
        groupId,
        type: 'database-dup',
        transaction: group.transaction,
        numOccurrencesToShow: 1,
      })
    }

    if (group.occurrences > 1) {
      spreadsheetPages.push({
        groupId,
        type: 'spreadsheet-dup',
        transaction: group.transaction,
        numOccurrencesToShow: group.occurrences,
      })
    }
  })

  return [...databasePages, ...spreadsheetPages]
}
